var exports = {
  "q": "GuildAcronym.module__acronym___dTY2ZF",
  "Q": "GuildAcronym.module__text___dTY2ZF",
};

module.exports = exports;
